<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-24
    	描述：后台系统内容区域
    -->
  <div class="right-content pr">
    <!--头部-->
    <Head></Head>
    <!--内容区域-->
    <div class="right-content-box" >
      <div class="subject-wrap" style="background: #F6F8FB;">
        <router-view />
      </div>
      <div class="copyright" v-if="baseInfo.w7"> 
        <div class="copyright" v-if="!baseInfo.w7.footerleft">
          Powered by <a href="http://www.w7.cc"><b>微擎</b></a> v{{baseInfo.w7.ims_version}}  {{baseInfo.w7.copyright}} <a href="http://www.w7.cc">www.w7.cc</a>
        </div>
        <div class="copyright" v-if="baseInfo.w7.footerleft">
          {{baseInfo.w7.footerleft}}
        </div>
        <div v-if="baseInfo.w7.icp">备案号：<a :href="baseInfo.w7.icp_url" target="_blank">{{baseInfo.w7.icp}}</a></div>
      </div>
      
    </div>
  </div>
</template>

<script>
  import Head from '@/views/layout/Head.vue';
  export default {
    components: {
      Head
    },
    data() {
      return {};
    },
    inject: ['baseInfo'],
    created() {},
    methods: {}
  };
</script>

<style scroped="scroped">
.copyright{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/RightContentb.vue